import { useSelector } from 'react-redux';
import { noiseWaveForLeadSelector } from '../../wave/selectors/wave.selectors';
import { isWaveManual } from '../../wave/utils/wave.util';
import { ManualDelineationBar } from './ManualDelineationBar';
import { useStrip } from '../hooks/useStrip';
import { useStripWindow } from '../hooks/useStripWindow';
import { noiseTagFilterSelector } from '../selectors/strip.selectors';

export const ManualNoiseBar = () => {
  const { leads, stripId } = useStrip();
  const tagFilter = useSelector(noiseTagFilterSelector(stripId));
  const waves = useSelector(noiseWaveForLeadSelector(leads, tagFilter));

  const { start: minOffset, end: maxOnset } = useStripWindow();
  const displayedWaves = waves.filter(
    (wave) =>
      isWaveManual(wave) && wave.offset > minOffset && wave.onset < maxOnset,
  );

  return <ManualDelineationBar waves={displayedWaves} />;
};
